// extracted by mini-css-extract-plugin
export var description = "Card-module--description--b0162";
export var documents = "Card-module--documents--fa6ef";
export var fadeInAnimation = "Card-module--fadeInAnimation--68263";
export var icon = "Card-module--icon--51be1";
export var img = "Card-module--img--ee596";
export var item = "Card-module--item--24939";
export var link = "Card-module--link--533ea";
export var linkRow = "Card-module--linkRow--21704";
export var list = "Card-module--list--03732";
export var paper = "Card-module--paper--39313";
export var solution = "Card-module--solution--12339";
export var title = "Card-module--title--8a973";
export var titleLabel = "Card-module--titleLabel--678a8";
export var withShadow = "Card-module--withShadow--67e16";
export var withShadowSm = "Card-module--withShadowSm--3e6e8";